module.exports = __webpack_public_path__ + "static/media/hands.f7a106f8.jpg";